// extracted by mini-css-extract-plugin
export default {"Form":"NewPasswordPage_Form__T33nq","Disclaimer":"NewPasswordPage_Disclaimer__BuzRf","Btn":"NewPasswordPage_Btn__kc2oS","Checkbox":"NewPasswordPage_Checkbox__7u8RN"};